import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import { OfferStatus } from '@hooks/negotiations/useNegotiationStatus';
import { OfferDetails } from '@interfaces/models/negotiation/negotiationEvent';
import PriceBreakDownTooltip from '../../../price-breakdown-tooltip/price-breakdown-tooltip';
import styles from './status-message.module.scss';

interface StatusMessageProps {
  offerStatus: OfferStatus;
  lastEventOfferDetails?: OfferDetails;
}

export const StatusMessage = ({ offerStatus, lastEventOfferDetails }: StatusMessageProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mmao__status}>
      <div className={styles.mmao__status__item}>
        <div className={clsx(styles.mmao__status__userMessage, styles['offerStatus__fontColor--' + offerStatus.id])}>
          <Icon
            name={offerStatus.icon}
            className={styles.mmao__status__icon}
            ariaHidden
          />
          {!offerStatus.isNegoPriceShown && <span>{offerStatus.message}</span>}
          {offerStatus.isNegoPriceShown && (
            <>
              <span>
                <PriceBreakDownTooltip
                  isSeller={offerStatus.isSeller}
                  offerDetails={lastEventOfferDetails}
                  direction="right"
                >
                  {offerStatus.message}
                </PriceBreakDownTooltip>
              </span>
              <span
                className={clsx(styles.mmao__status__negoPrice, styles['offerStatus__priceBgColor--' + offerStatus.id])}
                data-cy="mmao_nego_price"
              >
                {offerStatus.price}
              </span>
            </>
          )}
        </div>
        {offerStatus.isSeller && offerStatus.isYouEarnShown && (
          <div className={styles.mmao__status__userMessage__money}>
            {'(' + t('MMAO.SELLER.YOU_EARN')}
            {': '}
            {offerStatus.sellerPrice + ')'}
          </div>
        )}
      </div>
      {offerStatus.isLastOffer && (
        <div
          className={clsx(styles.mmao__status__item, styles.mmao__status__item__lastOffer)}
          data-cy="mmao_last_offer_notification"
        >
          {t('MMAO.POPIN.OTHER_MSG.RESPONSE_LAST_OFFER')}
        </div>
      )}
      <div className={styles.mmao__status__item}>{offerStatus.subMessage}</div>
    </div>
  );
};
